import axios from "axios";

const domains = {
  local: "localhost:8080",
  staging: "vibehut-staging.herokuapp.com",
  prod: "vibehut.io",
};

const protocols = {
  local: "http://",
  staging: "https://",
  prod: "https://",
};

const getEnv = () => {
  switch (window.location.host) {
    case "vibehut-staging.herokuapp.com":
      return "staging";

    case "vibehut.io":
      return "prod";

    default:
      return "local";
  }
};

const environment = getEnv();

export const domain = domains[environment];
export const baseURL = `${protocols[environment]}${domain}`;
export const frontEndURL = `${protocols[environment]}${window.location.host}`;

export default axios.create({
  baseURL: `${baseURL}/api/v1`,
  validateStatus: (status) => status < 500,
});
